<template>
  <div class="invoice-downloader">
    <component
      :is="downloadInProgress ? 'span' : 'a'"
      v-if="invoiceExtID === null"
      href="#"
      @click.prevent="generateInvoice">
      <template v-if="!invoiceInProgress">
        <template v-if="useInvoices || isInvoice">
          {{ $t('common.invoiceDownloader.generateInvoice') }}
        </template>
        <template v-else>
          {{ $t('common.invoiceDownloader.generateReceipt') }}
        </template>
      </template>
      <template v-if="invoiceInProgress">
        <template v-if="useInvoices">
          {{ $t('common.invoiceDownloader.generatingInvoice') }}
        </template>
        <template v-else>
          {{ $t('common.invoiceDownloader.generatingReceipt') }}
        </template>
      </template>
    </component>
    <component
      :is="downloadInProgress === inquiryID ? 'span' : 'a'"
      v-if="invoiceExtID !== null"
      href="#"
      @click.prevent="downloadInvoice">
      <template v-if="!downloadInProgress">
        <template v-if="isInvoice">
          {{ $t('common.invoiceDownloader.downloadInvoice', { invoiceNumber }) }}
        </template>
        <template v-else>
          {{ $t('common.invoiceDownloader.downloadReceipt', { 'receiptNumber': invoiceNumber }) }}
        </template>
      </template>
      <template v-if="downloadInProgress">
        <template v-if="isInvoice">
          {{ $t('common.invoiceDownloader.downloadingInvoice') }}
        </template>
        <template v-else>
          {{ $t('common.invoiceDownloader.downloadingReceipt') }}
        </template>
      </template>
    </component>

    <a
      v-if="!isOldInvoice"
      href="#"
      class="invoice-preview"
      @click.prevent="$bus.$emit('invoice-details-popup-display', invoiceID)">
      {{ $t('invoices.listItem.seeDetails') }}
    </a>
  </div>
</template>

<script>
import ErrorUtils from './../helpers/ErrorUtils.js';

export default {
  name: 'invoice-downloader',
  props: [
    'documentType',
    'inquiryID',
    'invoiceExtID',
    'invoiceID',
    'invoiceNumber',
    'isOldInvoice'
  ],
  computed: {
    isInvoice () {
      return this.documentType === 'fvat' || !this.documentType;
    },
    useInvoices () {
      return this.$store.state.config.fakturownia.document_type === 'fvat';
    }
  },
  data () {
    return {
      downloadInProgress: false,
      invoiceInProgress: false
    };
  },
  methods: {
    downloadInvoice () {
      if (this.downloadInProgress) {
        return;
      }

      this.downloadInProgress = true;

      if (this.isOldInvoice) {
        this.$http.post('/panel/fakturownia/download', {
          inquiry_id: this.inquiryID
        }, {
          responseType: 'blob'
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.$t('common.invoiceDownloader.filenameInvoice', { invoiceNumber: this.invoiceNumber }));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.downloadInProgress = false;
        }).catch(error => {
          ErrorUtils.handleSubmitError(error, '/panel/fakturownia/download', this.$router, this.$bus, this.downloadInvoice.bind(this));
          this.downloadInProgress = false;
        });
      } else {
        this.$http.get('/panel/invoices/download/' + parseInt(this.invoiceID, 10), {
          responseType: 'blob'
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          if (this.isInvoice) {
            link.setAttribute('download', this.$t('common.invoiceDownloader.filenameInvoice', { invoiceNumber: this.invoiceNumber }));
          } else {
            link.setAttribute('download', this.$t('common.invoiceDownloader.filenameReceipt', { receiptNumber: this.invoiceNumber }));
          }

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.downloadInProgress = false;
        }).catch(error => {
          ErrorUtils.handleSubmitError(error, '/panel/invoices/download/' + parseInt(this.invoiceID, 10), this.$router, this.$bus, this.downloadInvoice.bind(this));
          this.downloadInProgress = false;
        });
      }
    },
    generateInvoice () {
      if (this.invoiceInProgress) {
        return;
      }

      this.invoiceInProgress = true;

      this.$http.get('/panel/invoices/integrate/' + parseInt(this.invoiceID, 10)).then(response => {
        if (response.data.success === 1 && !response.data.message) {
          this.$bus.$emit('invoices-list-reload-needed');

          if (this.useInvoices) {
            this.$bus.$emit('notification-display', {
              message: this.$t('common.invoiceDownloader.successMessageInvoice', { externalInvoiceNumber: response.data.external_invoice_number }),
              type: 'success'
            });
          } else {
            this.$bus.$emit('notification-display', {
              message: this.$t('common.invoiceDownloader.successMessageReceipt', { externalInvoiceNumber: response.data.external_invoice_number }),
              type: 'success'
            });
          }

          this.$bus.$emit('invoice-downloader-update-data', {
            document_type: this.useInvoices ? 'fvat' : 'receipt',
            inquiry_id: this.inquiryID,
            invoice_id: this.invoiceID,
            invoice_external_id: response.data.external_invoice_id,
            invoice_number: response.data.external_invoice_number
          });
        } else {
          this.$bus.$emit('alert-display', {
            title: this.$t('invoices.listItem.errorNotCreated'),
            desc: this.$t('invoices.listItem.errorNotCreatedDesc') + response.data.message,
            okLabel: this.$t('common.ui.ok'),
            okClick: () => true,
            isDanger: true
          });
        }

        this.invoiceInProgress = false;
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/invoices/integrate/' + parseInt(this.invoiceID, 10), this.$router, this.$bus, this.generateInvoice.bind(this));
        this.invoiceInProgress = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.invoice-downloader {
  font-weight: 400;
  margin-top: 5px;

  .invoice-preview {
    margin-left: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/InvoiceDownloader.vue